import React, { Component } from 'react';
import { Field, reduxForm, change, formValueSelector, FieldArray } from 'redux-form';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import { injectIntl } from 'react-intl';
import cx from 'classnames';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import FormControl from 'react-bootstrap/FormControl';
import FormGroup from 'react-bootstrap/FormGroup';
import Button from 'react-bootstrap/Button';

import Loader from '../../Common/Loader';
import ImageUploadComponent from '../../../components/Common/ImageUploadComponent';

import validate from './validate';
import submit from './submit';
import messages from '../../../locale/messages';
import { formatLocale } from '../../../helpers/formatLocale';
import { updateTempImages } from '../../../actions/siteadmin/TempImages/updateTempImages';
import { api, homepageUploadDir } from '../../../config';

import addIcon from '../../../../public/Icons/plusIcon.svg';
import trashIcon from '../../../../public/Icons/deleteIocn.svg';

import s from './SafetySettingsForm.css';
import bt from '../../../components/commonStyle.css';

export class SafetySettingsForm extends Component {

	constructor(props) {
		super(props)
		this.state = {
			selectedLanguages: []
		};
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		const { dynamicSafetyGridTitle } = nextProps;
		let filteredLanguages = dynamicSafetyGridTitle?.map((item) => { return item?.language })
		this.setState({ selectedLanguages: filteredLanguages });
	}

	successLogo = async (fileName) => {
		const { change, updateTempImages } = this.props;
		await change('safetyGridImage4', fileName);
		await updateTempImages('Homepage', 'safetyGridImage4', fileName);
	}

	successBanner = async (fileName) => {
		const { change, updateTempImages } = this.props;
		await change('safetyGridImage3', fileName);
		await updateTempImages('Homepage', 'safetyGridImage3', fileName);
	}

	successAppStore = async (fileName) => {
		const { change, updateTempImages } = this.props;
		await change('safetyGridImage2', fileName);
		await updateTempImages('Homepage', 'safetyGridImage2', fileName);
	}

	successPlayStore = async (fileName) => {
		const { change, updateTempImages } = this.props;
		await change('safetyGridImage1', fileName);
		await updateTempImages('Homepage', 'safetyGridImage1', fileName);
	}

	renderField = ({ input, label, type, meta: { touched, error }, labelClass, fieldClass, placeholder, maxlength, inputClassname }) => {
		const { formatMessage } = this.props.intl
		return (
			<Form.Group className={inputClassname}>
				{label && <label className={bt.labelText} >{label}</label>}
				<Form.Control {...input} placeholder={label} type={type} className={bt.formControlInput} maxlength={maxlength} />
				{touched && error && <span className={cx(bt.errorMessage, 'errorRTL')}>{formatMessage(error)}</span>}
			</Form.Group>
		)
	}
	renderFormControlTextArea = ({ input, label, meta: { touched, error }, children, className, maxlength }) => {
		const { formatMessage } = this.props.intl
		return (
			<div>
				<FormGroup className={cx(s.formGroup, 'noMargin')}>
					<div>
						<label className={bt.labelText} >{label}</label>
					</div>
					<div>
						<FormControl
							{...input}
							className={className}
							placeholder={label}
							as="textarea"
							rows="3"
							maxlength={maxlength}
						>
							{children}
						</FormControl>
						{touched && error && <span className={cx(bt.errorMessage, 'errorRTL')}>{formatMessage(error)}</span>}
					</div>
				</FormGroup>
			</div>
		);
	}

	renderFormControlSelect = ({ input, meta: { touched, error }, className, children, label }) => {
		const { formatMessage } = this.props.intl;
		return (
			<div className={bt.space5}>
				{label && <label className={bt.labelText} >{label}</label>}
				<FormControl as="select" {...input} className={className} >
					{children}
				</FormControl>
				{touched && error && <span className={cx(bt.errorMessage, 'errorRTL')}>{formatMessage(error)}</span>}
			</div>
		)
	}

	renderFieldArray = ({ fields, meta: { touched, error } }) => {
		const { formatMessage } = this.props.intl;
		const { languageList } = this.props;
		const { selectedLanguages } = this.state;

		return (
			<div className={bt.languageBox}>
				{
					fields && fields?.map((userApp, index) => {
						let fieldLength = fields.length - 1;
						const currentLanguage = fields?.get(index)?.language;
						const availableLanguages = languageList?.filter(locale => !selectedLanguages?.includes(locale) || locale === currentLanguage);
						return (
							<div key={index}>
								<Row>
									<Col lg={6} md={6} sm={12} xs={12} className={bt.mb30Xs}>
										<Field name={`${userApp}.language`} component={this.renderFormControlSelect} className={cx('noMargin', bt.formControlSelect, bt.formControlInput)} label={formatMessage(messages.language)}>
											<option value={''} >{formatMessage(messages.chooseLanguageLabel)}</option>
											{availableLanguages?.map((locale, index) => {
												return (
													<option value={locale} key={index}>{formatLocale(locale)}</option>
												)
											})}
										</Field>
										<Field name={`${userApp}.value`} type="text" component={this.renderField} inputClassname={'noMargin'} label={formatMessage(messages.userApptitle)} />
									</Col>
									<Col lg={6} md={6} sm={12} xs={12} className={bt.noMargin}>
										<Field name={`${userApp}.description`} component={this.renderFormControlTextArea} label={formatMessage(messages.userAppContent)} className={cx(bt.textAreaHeight)} />
									</Col>
								</Row>
								<div className={cx(bt.languageBtnContainer, 'darkLink', 'svgImg', { [bt.languageBtnContainerOne]: index != 0 })} >
									{(fields.length <= languageList?.length - 1) && fieldLength == index &&
										<Button className={cx(bt.languageBtn, "textWhite", "btnBorderWhte")} onClick={() => fields.length <= languageList?.length - 1 && fields.push({})}>
											<img src={addIcon} alt='addIcon' />
											<span>	{formatMessage(messages.addLanguage)}</span>
										</Button>
									}
									{index != 0 &&
										<div>
											<Button className={cx(bt.languageBtn, "textWhite", "btnBorderWhte")} onClick={() => fields.remove(index)}>
												<img src={trashIcon} alt='addIcon' />
												<span>{formatMessage(messages.deleteLanguage)}</span>
											</Button>
										</div>
									}
								</div>
							</div>
						)
					})
				}
			</div>
		)
	}

	render() {
		const { handleSubmit, safetyGridImage1, safetyGridImage2, safetyGridImage3, loading, submitting, safetyGridImage4, safetyGridImage1Loader, safetyGridImage2Loader, safetyGridImage3Loader, safetyGridImage4Loader } = this.props;
		const { formatMessage } = this.props.intl;

		return (
			<div className={cx('cardSection', s.widthInner, bt.space5, s.responsiveNoPadding)}>
				<div className={s.responsiveNoPadding}>
					<Card className={s.card}>
						<Form className={s.fullWidth} onSubmit={handleSubmit(submit)}>
							<h1 className={cx('textAlignRightRTL', s.headingTwo, 'textWhite')}>{formatMessage(messages.safetySectionSettings)}</h1>
							<Row>
								<Col lg={6} md={6} sm={12} xs={12} className={bt.space2}>
									<Form.Group className={s.formGroup}>
										<div className={cx(s.profileImgSection, 'bgBlackTwo')}>
											<div className={'commonFilepicker'}>
												<ImageUploadComponent
													className={cx(bt.btnPrimary, 'fileNoPadding', s.btnWidthadmin)}
													subTextClass={cx(s.subText, 'textWhiteTwo')}
													subText={formatMessage(messages.maximumUploadSizeLabel)}
													defaultMessage={formatMessage(messages.chooseFile)}
													postUrl={api.apiEndpoint + '/uploadHomepageImage'}
													handleDropzone={this.successLogo}
													loaderName={'safetyGridImage1Loader'}
													loader={safetyGridImage1Loader}
													fieldName={'safetyGridImage4'}
													formName={'SafetySettingsForm'}
													imageSrc={safetyGridImage4 ? api.apiEndpoint + homepageUploadDir + 'medium_' + safetyGridImage4 : null}
													label={formatMessage(messages.backGroundImage)}
													labelClass={cx(s.textAlignLeft, 'textAlignLeft', s.dropzoneLabelTitle)}
												/>
											</div>
										</div>
									</Form.Group>
								</Col>
								<Col lg={6} md={6} sm={12} xs={12} className={bt.space2}>
									<Form.Group className={s.formGroup}>
										<div className={cx(s.profileImgSection, 'bgBlackTwo')}>
											<div className={'commonFilepicker'}>
												<ImageUploadComponent
													className={cx(bt.btnPrimary, 'fileNoPadding', s.btnWidthadmin)}
													subTextClass={cx(s.subText, 'textWhiteTwo')}
													subText={formatMessage(messages.maximumUploadSizeLabel)}
													defaultMessage={formatMessage(messages.chooseFile)}
													postUrl={api.apiEndpoint + '/uploadHomepageImage'}
													handleDropzone={this.successBanner}
													loaderName={'safetyGridImage2Loader'}
													loader={safetyGridImage2Loader}
													fieldName={'safetyGridImage3'}
													formName={'SafetySettingsForm'}
													imageSrc={safetyGridImage3 ? api.apiEndpoint + homepageUploadDir + 'medium_' + safetyGridImage3 : null}
													label={formatMessage(messages.safetyImage3)}
													labelClass={cx(s.textAlignLeft, 'textAlignLeft', s.dropzoneLabelTitle)}
												/>
											</div>
										</div>
									</Form.Group>
								</Col>
								<Col lg={6} md={6} sm={12} xs={12} className={bt.space2}>
									<Form.Group className={s.formGroup}>
										<div className={cx(s.profileImgSection, 'bgBlackTwo')}>
											<div className={'commonFilepicker'}>
												<ImageUploadComponent
													className={cx(bt.btnPrimary, 'fileNoPadding', s.btnWidthadmin)}
													subTextClass={cx(s.subText, 'textWhiteTwo')}
													subText={formatMessage(messages.maximumUploadSizeLabel)}
													defaultMessage={formatMessage(messages.chooseFile)}
													postUrl={api.apiEndpoint + '/uploadHomepageImage'}
													handleDropzone={this.successPlayStore}
													loaderName={'safetyGridImage3Loader'}
													loader={safetyGridImage3Loader}
													fieldName={'safetyGridImage1'}
													formName={'SafetySettingsForm'}
													imageSrc={safetyGridImage1 ? api.apiEndpoint + homepageUploadDir + 'medium_' + safetyGridImage1 : null}
													label={formatMessage(messages.safetyImage1)}
													labelClass={cx(s.textAlignLeft, 'textAlignLeft', s.dropzoneLabelTitle)}
												/>
											</div>
										</div>
									</Form.Group>
								</Col>
								<Col lg={6} md={6} sm={12} xs={12} className={bt.space2}>
									<Form.Group className={s.formGroup}>
										<div className={cx(s.profileImgSection, 'bgBlackTwo')}>
											<div className={'commonFilepicker'}>
												<ImageUploadComponent
													className={cx(bt.btnPrimary, 'fileNoPadding', s.btnWidthadmin)}
													subTextClass={cx(s.subText, 'textWhiteTwo')}
													subText={formatMessage(messages.maximumUploadSizeLabel)}
													defaultMessage={formatMessage(messages.chooseFile)}
													postUrl={api.apiEndpoint + '/uploadHomepageImage'}
													handleDropzone={this.successAppStore}
													loaderName={'safetyGridImage4Loader'}
													loader={safetyGridImage4Loader}
													fieldName={'safetyGridImage2'}
													formName={'SafetySettingsForm'}
													imageSrc={safetyGridImage2 ? api.apiEndpoint + homepageUploadDir + 'medium_' + safetyGridImage2 : null}
													label={formatMessage(messages.safetyImage2)}
													labelClass={cx(s.textAlignLeft, 'textAlignLeft', s.dropzoneLabelTitle)}
												/>
											</div>
										</div>
									</Form.Group>
								</Col>

								<Col lg={6} md={6} sm={12} xs={12}>
									<Form.Group className={cx(s.formGroup, 'mb30')}>
										<div>
											<Field name="safetyGridLink1" type="text" component={this.renderField} label={formatMessage(messages.playstorelink)} inputClassname={'noMargin'} />
										</div>
									</Form.Group>
								</Col>
								<Col lg={6} md={6} sm={12} xs={12}>
									<Form.Group className={cx(s.formGroup, 'mb30')}>
										<div>
											<Field name="safetyGridLink2" type="text" component={this.renderField} label={formatMessage(messages.appstorelink)} inputClassname={'noMargin'} />
										</div>
									</Form.Group>
								</Col>

								<Col lg={12} md={12} sm={12} xs={12}>
									<Form.Group className={cx(s.formGroup, 'mb0', bt.paddingTop5, bt.languageBtnDivider)}>
										<div>
											<FieldArray name="safetyGridTitle1" type="text" component={this.renderFieldArray} />
										</div>
									</Form.Group>
								</Col>

								<Col lg={12} md={12} sm={12} xs={12} className={cx(bt.textAlignRight, bt.spaceTop5, bt.paddingTop5, bt.languageBtnDivider, 'textAlignLeftRTL', 'loadingBtnRTL')}>
									<Form.Group className={s.formGroup}>
										<div className={s.displayInlineBlock}>
											<Loader
												type={"button"}
												label={formatMessage(messages.submitButton)}
												show={loading}
												buttonType={'submit'}
												className={cx(bt.btnPrimary, bt.clickBtn)}
												disabled={submitting || loading}
												isSuffix={true}
											/>
										</div>
									</Form.Group>
								</Col>
							</Row>
						</Form>
					</Card>
				</div>
			</div>
		)
	}
}
SafetySettingsForm = reduxForm({
	form: 'SafetySettingsForm',
	onSubmit: submit,
	validate
})(SafetySettingsForm);

const selector = formValueSelector('SafetySettingsForm');

const mapState = (state) => ({
	safetyGridImage1: selector(state, 'safetyGridImage1'),
	safetyGridImage2: selector(state, 'safetyGridImage2'),
	safetyGridImage3: selector(state, 'safetyGridImage3'),
	safetyGridImage4: selector(state, 'safetyGridImage4'),
	loading: state?.loader?.SafetySettingsForm,
	safetyGridImage1Loader: state?.loader?.safetyGridImage1Loader,
	safetyGridImage2Loader: state?.loader?.safetyGridImage2Loader,
	safetyGridImage3Loader: state?.loader?.safetyGridImage3Loader,
	safetyGridImage4Loader: state?.loader?.safetyGridImage4Loader,
	dynamicSafetyGridTitle: selector(state, 'safetyGridTitle1'),
	languageList: state?.runtime?.availableLocales,
});

const mapDispatch = {
	updateTempImages,
	change
}

export default injectIntl(withStyles(s, bt)(connect(mapState, mapDispatch)(SafetySettingsForm)));
